import {
  Box,
  Flex,
  List,
  ListIcon,
  ListItem,
  Text,
  Badge,
  useColorModeValue as mode,
} from "@chakra-ui/react";

import { HiCheckCircle } from "react-icons/hi";

const PriceDisplay = (props) => {
  const { price, pricingCurrency, duration, ...rest } = props;
  const currency = pricingCurrency || "CAD";

  const formatted = new Intl.NumberFormat("en", {
    style: "currency",
    currency,
    currencyDisplay: "narrowSymbol",
    maximumFractionDigits: 0,
  }).format(price);

  return (
    <Flex
      w="100%"
      align="center"
      fontWeight="extrabold"
      whiteSpace="nowrap"
      {...rest}
    >
      <Text fontSize="6xl" lineHeight="1" letterSpacing="tight">
        {formatted}
      </Text>
      <Text fontSize="2xl" marginStart="1" alignSelf="flex-end">
        {duration}
      </Text>
    </Flex>
  );
};
const PricingDetail = (props) => {
  const { children, iconProps = {}, ...rest } = props;
  return (
    <ListItem display="flex" alignItems="center" fontWeight="medium" {...rest}>
      <ListIcon
        fontSize="2xl"
        as={HiCheckCircle}
        color="gray.400"
        marginEnd="4"
        mt="1"
        {...iconProps}
      />
      <Text as="span" display="inline-block">
        {children}
      </Text>
    </ListItem>
  );
};

export const PricingCard = (props) => {
  const {
    features,
    name,
    description,
    price,
    pricingCurrency,
    duration,
    colorScheme: c,
    actionButton,
    actionButtonHelperText,
    badgeText,
    iconProps = {},
    ...rest
  } = props;
  return (
    <Box
      bg={mode("white", "gray.800")}
      shadow="md"
      w="full"
      maxW="lg"
      mx="auto"
      rounded="lg"
      overflow="hidden"
      data-testid={`pricing-card-${name.toLowerCase()}`}
      {...rest}
    >
      <Box bg={`${c}.600`} px="8" py="8" color="white">
        <Text fontWeight="bold" fontSize="lg">
          {name}
          {badgeText && <Badge float="right">{badgeText}</Badge>}
        </Text>
        <PriceDisplay
          my="2"
          price={price}
          pricingCurrency={pricingCurrency}
          duration={duration}
        />
        {description}
      </Box>
      <Box px="8" pt="6">
        {actionButton}
        <Text
          mt="2"
          color={mode("gray.700", "gray.400")}
          align="center"
          fontSize="sm"
        >
          {actionButtonHelperText}
        </Text>
      </Box>
      <Box px="8" pt="10" pb="12">
        <List stylePosition="outside" spacing="4">
          {features.map((feature, index) => (
            <PricingDetail key={index} iconProps={iconProps}>
              {feature}
            </PricingDetail>
          ))}
        </List>
      </Box>
    </Box>
  );
};
